"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UserSubscriptionService = /*#__PURE__*/function () {
  function UserSubscriptionService() {
    _classCallCheck(this, UserSubscriptionService);
  }

  _createClass(UserSubscriptionService, null, [{
    key: "isEditUserSubscriptionRequestValid",
    value: function isEditUserSubscriptionRequestValid(request) {
      if (request === null || request === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        auth0UserId: _joiBrowser["default"].string(),
        email: _joiBrowser["default"].string(),
        tenant: _joiBrowser["default"].string(),
        userSubscriptionId: _joiBrowser["default"].object().keys({
          auth0UserId: _joiBrowser["default"].string(),
          tenant: _joiBrowser["default"].string()
        }),
        subscriptions: _joiBrowser["default"].array().items(_joiBrowser["default"].object().keys({
          type: _joiBrowser["default"].string(),
          optOuts: _joiBrowser["default"].array().items(_joiBrowser["default"].string()),
          deviceId: _joiBrowser["default"].string().allow(null),
          deviceName: _joiBrowser["default"].string().allow(null),
          deviceToken: _joiBrowser["default"].string().allow(null),
          provider: _joiBrowser["default"].string().allow(null),
          webhookUrl: _joiBrowser["default"].string().allow(null)
        })),
        disableNotifications: _joiBrowser["default"]["boolean"](),
        receiveMyActions: _joiBrowser["default"]["boolean"]()
      });

      return _joiBrowser["default"].validate(request, schema).error === null;
    }
  }, {
    key: "getUserSubscription",
    value: function getUserSubscription(auth0UserId, email) {
      if (!auth0UserId) {
        return Promise.reject(new Error('Missing User ID'));
      }

      return this.httpService.get("/".concat(auth0UserId, "/subscriptions").concat(email ? "?userEmail=".concat(email) : ''));
    }
  }, {
    key: "updateUserSubscription",
    value: function updateUserSubscription(auth0UserId, request) {
      var _this = this;

      if (!auth0UserId) {
        return Promise.reject(new Error('Missing User ID'));
      }

      if (!UserSubscriptionService.isEditUserSubscriptionRequestValid(request)) {
        return Promise.reject(new Error('Invalid edit user subscription request'));
      }

      return new Promise(function (resolve, reject) {
        _this.httpService.put("/".concat(auth0UserId, "/subscriptions"), request).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }]);

  return UserSubscriptionService;
}();

exports["default"] = UserSubscriptionService;
UserSubscriptionService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_NOTIFICATION_API : '', "/users")
});